import { DraggableNode } from '@thesisedu/feature-widgets-core'
import { createCommand, LexicalCommand } from 'lexical'

export interface DropFilePayload {
  files: File[]
  nodes: DraggableNode[]
}
export const DROP_FILE_COMMAND: LexicalCommand<DropFilePayload> = createCommand()
